import { useEffect, useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { SermonContext } from "../contexts/SermonContext";
import { ColumnContext } from "../contexts/ColumnContext";
import { ModalContext } from "../contexts/ModalContext";

export const useScript = (src: string, onload: any) => {
  useEffect(() => {
    const script = document.createElement("script");
    const body = document.getElementsByTagName("body")[0];
    script.src = src;
    script.type = "text/javascript";

    script.onload = onload;
    body.appendChild(script);

    return () => {
      body.removeChild(script);
    };
  }, [src, onload]);
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const useDisableScrollSnap = () => {
  useEffect(() => {
    // 스크롤 스냅 비활성화
    document.documentElement.style.scrollSnapType = 'none';
    document.body.style.scrollSnapType = 'none';
    
    // 컴포넌트 언마운트 시 원래대로 복구
    return () => {
      document.documentElement.style.scrollSnapType = 'y mandatory';
      document.body.style.scrollSnapType = '';
    };
  }, []);
};
export const useSermon = () => {
  const context = useContext(SermonContext);
  if (context === undefined) {
    throw new Error('useSermon must be used within a SermonProvider');
  }
  return context;
};

export const useColumn = () => {
  const context = useContext(ColumnContext);
  if (context === undefined) {
    throw new Error('useColumn must be used within a ColumnProvider');
  }
  return context;
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
